module.exports = __webpack_public_path__ + "static/media/envelopePurolator.dc4e4539.png";